export class UserEventTrackerSessionIdNotSetError extends Error {
  constructor() {
    super('Session id is used before it is set.');
  }
}